const styles = {
    container: {
      pt: 10,

      // paddingTop: '15px',
    //   '@media (min-width:600px)': {
    //     paddingTop: '11%',
    //   },
    //   '@media (min-width:960px)': {
    //     paddingTop: '8%',
    //   },
    //   '@media (min-width:1280px)': {
    //     paddingTop: '7%',
    //   },
    },
    heading: {
      fontFamily: 'Poppins, Arial, sans-serif',
      fontSize: 40,
      fontWeight: 600,
      color: '#000000',
      textAlign: 'center',
    },
    subHeading: {
      fontFamily: 'Poppins, Arial, sans-serif',
      fontSize: '16px',
      fontWeight: 600,
      color: '#000000',
      textAlign: 'center',
    },
    divider: {
      width: { xs: '95%', sm: '95%', md: '80%', lg: '80%' },
      //   height: '2px',
      border: '2px solid black',
      marginBottom: 9,
      textAlign: 'center',
      margin: '0 auto',
      mt: "2px",
    },
    dot: (isActive) => ({
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      backgroundColor: isActive ? "black" : "lightgray",
      cursor: "pointer",
    }),
  };
  
  // Add CSS for the slider, including adjustments for mobile and center slide styling on desktop
const sliderStyles = `
  .slider-container-mobile .slider-image {
    width: 90%;
    border: 2px solid black;
    transition: transform 0.3s ease;
    border-radius: 20px;
  }

  /* Mobile screen adjustment */
  @media (max-width: 600px) {
    .slider-container-mobile .slider-image {
      width: 95%;
    }
  }

  /* Center slide styling for desktop */
  @media (min-width: 1024px) {
    .slider-container-mobile .slick-center {
      transform: scale(1.1, 1.3); /* Scale both width and height */
      transition: transform 0.3s ease;
    }
    .slider-container-mobile .slick-center .slider-image {
      width: 100%; /* Ensures the image fully fills the container-mobile */
      height: auto; /* Maintain aspect ratio */
    }
  }

  .custom-dots li button:before {
    font-size: 16px;
    color: #0D8B5A; /* Default color for unselected dots */
  }

  .custom-dots li.slick-active button:before {
    color: #F9792D; /* Color for the selected dot */
  }
`;

// Append CSS directly to the document head for global styles
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = sliderStyles;
document.head.appendChild(styleSheet);

  
  export default styles;
  